import { motion } from "framer-motion";
import { EVENT } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const FloatingWhatsApp = () => {
  const { t } = useLang();
  return (
    <motion.a
      href={EVENT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.5, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-2.5 rounded-full bg-[#25D366] py-3.5 pl-3.5 pr-4 shadow-[0_8px_30px_rgba(37,211,102,0.45)]"
      aria-label="Chat on WhatsApp"
    >
      <span className="relative flex h-8 w-8 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-60" />
        <svg viewBox="0 0 24 24" className="relative h-7 w-7 fill-ink-900">
          <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm5.8 14.09c-.25.7-1.44 1.33-1.99 1.41-.53.08-1.17.11-1.89-.12-.44-.14-1-.33-1.72-.64-3.03-1.31-5-4.35-5.16-4.56-.15-.2-1.23-1.63-1.23-3.11 0-1.48.78-2.21 1.05-2.51.28-.3.6-.38.8-.38.2 0 .4.002.57.01.18.008.43-.07.67.51.25.6.85 2.08.92 2.23.07.15.12.33.02.53-.1.2-.15.33-.3.5-.15.18-.31.4-.44.53-.15.15-.3.31-.13.6.17.3.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.36 1.46.3.15.47.12.64-.07.17-.2.74-.86.94-1.16.2-.3.4-.25.67-.15.27.1 1.71.81 2 .96.3.15.5.22.57.35.07.12.07.72-.18 1.42z"/>
        </svg>
      </span>
      <span className="hidden text-sm font-semibold text-ink-900 sm:block">{t.footer.whatsappChat}</span>
    </motion.a>
  );
};
